export type RolePatient = 3;
export type RoleHospitals = 2;
export type RoleDoctor = 4;
export type RoleOperation = 1;
export type RoleInternalDoctor = 5;
export type RoleConvenio = 6;

export type Role =
  | RolePatient
  | RoleHospitals
  | RoleDoctor
  | RoleOperation
  | RoleInternalDoctor
  | RoleConvenio;

export const ROLE_PATIENT: RolePatient = 3;
export const ROLE_HOSPITALS: RoleHospitals = 2;
export const ROLE_DOCTOR: RoleDoctor = 4;
export const ROLE_OPERATION: RoleOperation = 1;
export const ROLE_INTERNAL_DOCTOR: RoleInternalDoctor = 5;
export const ROLE_CONVENIO: RoleConvenio = 6;

// Rótulo do grupo base (papel) para exibição na identidade do usuário — ex.: badge do Perfil.
// Distinto do "tipo" da listagem (Users/index.tsx: userTypeLabel), que tem outro contexto.
export const ROLE_LABEL: Record<number, string> = {
  [ROLE_OPERATION]: "Administrador",
  [ROLE_HOSPITALS]: "Usuário Hospitalar",
  [ROLE_PATIENT]: "Paciente",
  [ROLE_DOCTOR]: "Médico(a)",
  [ROLE_INTERNAL_DOCTOR]: "Médico(a) Senne",
  [ROLE_CONVENIO]: "Convênio",
};

export const roleLabel = (roleId?: number | null): string =>
  (roleId != null && ROLE_LABEL[roleId]) || "Usuário";

/**
 * O papel tem escopo hospitalar? Espelha `isAdminOrHospital` do backend, que é `isOneOfRoles([1, 2])`
 * em `GET /hospitals` e em `POST /hospitals/active`.
 *
 * Positivo de propósito. A trava anterior era lista de exclusão (`role_id !== ROLE_PATIENT && ...`),
 * e lista de exclusão é VERDADEIRA quando o papel ainda não chegou: no primeiro render `auth.user`
 * é `undefined`, `undefined !== ROLE_PATIENT` passa, e o paciente pedia `/hospitals` para receber
 * 403 e ver "Erro ao carregar hospitais". Medido em 2026-09-10 num login real de dev.
 *
 * Papel desconhecido devolve `false`: sem identidade não há escopo, e a dúvida não abre porta.
 */
export const hasHospitalScope = (roleId?: number | null): boolean =>
  roleId === ROLE_OPERATION || roleId === ROLE_HOSPITALS;
